var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgToolkitRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 13C19.6044 13 19.2178 13.1173 18.8889 13.3371C18.56 13.5568 18.3036 13.8692 18.1522 14.2346C18.0009 14.6001 17.9613 15.0022 18.0384 15.3902C18.1156 15.7781 18.3061 16.1345 18.5858 16.4142C18.8655 16.6939 19.2219 16.8844 19.6098 16.9616C19.9978 17.0387 20.3999 16.9991 20.7654 16.8478C21.1308 16.6964 21.4432 16.44 21.6629 16.1111C21.8827 15.7822 22 15.3956 22 15M18 9V1H6V13H13V6H1V18H9L18 9ZM13 22L19 16L13 22Z",
    stroke: "rgb(255, 73, 60)",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolkitRed);
export default __webpack_public_path__ + "static/media/toolkitRed.9a103889.svg";
export { ForwardRef as ReactComponent };